import { GET_PAGES_STUDENT, GET_PAGES_EDUCATOR } from '@monorepo/shared/src/graph/queries/books';
import { QueryResult, useQuery } from '@apollo/client';
import type { Asset, BookType } from '../../schema-generated-types-educator';
import { isStudentApp } from '@monorepo/shared/src/util/app-util';
import { StoreTypename } from '../../../types';

type Book = any; // TODO: typing
export type PageStoreState = {
  instructions?: Asset;
  books?: Book;
  loading: boolean;
  error?: any;
  refetch?: any;
};

export type PageStoreDispatch = undefined;
export type PageStore = [PageStoreState, PageStoreDispatch];

export const getDefaultPageStoreState = (): any => ({
  __typename: StoreTypename.USER,
});

const usePageStore = (bookType: BookType, letter?: string): PageStore => {
  const pageStore = isStudentApp
    ? studentPageStore(bookType, letter)
    : educatorPageStore(bookType, letter);
  return pageStore;
};

const studentPageStore = (bookType: BookType, letter?: string): PageStore => {
  const variables: any = {
    bookListWhere: {
      type: [bookType],
      edition: 2022,
    },
  };

  if (letter) {
    variables.pagesWhere = {
      character: {
        character: letter,
      },
    };
  }
  const { data, loading, error, refetch }: QueryResult<{ bookList: Book }> = useQuery(
    GET_PAGES_STUDENT,
    {
      variables,
    }
  );

  return [
    {
      instructions: data?.bookList?.instructions,
      books: data?.bookList?.books,
      loading,
      error,
      refetch,
    },
    undefined,
  ];
};
const educatorPageStore = (bookType: BookType, letter?: string): PageStore => {
  const variables: any = {
    booksWhere: {
      type: [bookType],
      edition: 2022,
    },
  };

  if (letter) {
    variables.pagesWhere = {
      character: {
        character: letter,
      },
    };
  }
  const { data, loading, error, refetch }: QueryResult<{ books: Book }> = useQuery(
    GET_PAGES_EDUCATOR,
    {
      variables,
    }
  );

  return [
    {
      books: data?.books,
      loading,
      error,
      refetch,
    },
    undefined,
  ];
};

export default usePageStore;
